interface ChevronLeftFilledProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

const ChevronLeftFilled = ({ className = '', ...props }: ChevronLeftFilledProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      {...props}
    >
      <path d="M15.41 7.41L14 6L8 12L14 18L15.41 16.59L10.83 12L15.41 7.41Z" fill="currentColor" />
    </svg>
  );
};

export default ChevronLeftFilled;
